import Vue from 'vue'
import router from '@/router'
export default {
  authorize() {
    router.beforeEach((to, from, next) => {
      sessionStorage.setItem("last_page", from.name);
      if (to.meta.allowAnonymous === true) return next()
      if (!localStorage.getItem('token')) return next('/login')
      if (new Date() - new Date(localStorage.getItem("token.time")) >= 1200000) return next('/login')
      //檢查逾時計時
      if (new Date() - new Date(localStorage.getItem("token.exp")) >= 1200000)
      {
        alert('由於您超過20分鐘未操作，系統已將您登出。')
        localStorage.clear()
        return next('/login')
      }
      Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
      Vue.http.headers.common['pathname'] = to.name
      Vue.http.headers.common['pathfullurl'] = to.path
      //console.log(to);
      next()
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/identity.js